// extracted by mini-css-extract-plugin
export var button = "_48-0";
export var icon = "_48-1";